import * as yup from "yup";

export const uploadReportSchema = yup.object().shape({
  serviceCategories: yup.array().notRequired(),
  comments: yup.string().notRequired(),
  reportType: yup.object().required("Please select a report type."),
  sponsor: yup.object().when("reportType", {
    is: (reportType) =>
      reportType?.name === "Sponsor Draft Report" ||
      reportType?.name === "Final Report",
    then: (schema) => schema.required("Please select a sponsor"),
    otherwise: (schema) => schema.nullable(),
  }),
  file: yup
    .mixed()
    // .required("File is required")
    .test(
      "fileSize",
      "File size should be less than 2MB",
      (value) => !value || value[0]?.size <= 2 * 1024 * 1024 // Check file size
    ),
  // .test(
  //   "fileType",
  //   "Unsupported file format",
  //   (value) =>
  //     !value ||
  //     ["image/jpeg", "image/png", "application/pdf"].includes(value[0]?.type) // Allowed formats
  // ),
});
